const headerLinks = [
    {
      title: "AI Investments",
      link: "/category/ai-investments",
    },
    {
      title: "Foundation Models",
      link: "/category/foundation-models",
    },
    {
      title: "AI Infrastructure",
      link: "/category/ai-infrastructure",
    },
    {
      title: "Policy and Regulation",
      link: "/category/policy-and-regulation",
    },
    {
      title: "Clean Energy and AI",
      link: "/category/clean-energy-and-ai",
    },
    {
      title: "Sectors",
      link: "/",
      isDropdown: true,
      option: [
        {
          title: "Cybersecurity",
          link: "/category/cybersecurity",
        },
        {
          title: "Financial Institutions",
          link: "/category/financial-institutions",
        },
        {
          title: "Energy",
          link: "/category/energy",
        },
        {
          title: "Medical",
          link: "/category/medical",
        },
        {
          title: "Agriculture",
          link: "/category/agriculture",
        },
        {
          title: "Education",
          link: "/category/education",
        },
        {
          title: "Transport",
          link: "/category/transport",
        },
      ],
    },
];

export default headerLinks;